<li class="menu-item-container">
    <a [routerLink]="item.route" [class.active]="item.route && isActive(item.route)" (click)="toggleExpand($event)"
        class="menu-link">
        @if(item.icon) {
        <mat-icon class="menu-icon">{{ item.icon }}</mat-icon>
        }
        <span>{{ item.label }}</span>

        @if(item.isParent && item.children) {
        <button class="expand-btn">
            @if(item.expanded) {
            <mat-icon>expand_less</mat-icon>
            }
            @else {
            <mat-icon>expand_more</mat-icon>
            }
        </button>
        }
    </a>

    @if(item.isParent && item.children) {
    <ul [class.expanded]="item.expanded" class="sub-menu">
        @for(childItem of item.children; track childItem) {
        <app-menu-item [item]="childItem"></app-menu-item>
        }
    </ul>
    }
</li>